import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-16 bg-[#1E2A4A] text-white" data-id="element-131">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-132">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-133">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-[#E76F51] rounded-full flex items-center justify-center mb-4 md:mb-6 shadow-lg shadow-[#E76F51]/20" data-id="element-134">
            <ShieldCheck className="text-white w-8 h-8 md:w-10 md:h-10" data-id="element-135" />
          </div>

          <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4" data-id="element-136">
            7 DÍAS — GARANTÍA TOTAL
          </h2>
          <p className="text-lg md:text-xl text-[#E76F51] font-bold mb-4 md:mb-6" data-id="element-137">
            7 días para probarlo o te devolvemos el 100%
          </p>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed" data-id="element-138">
            Abrís los tomos, probás los bonos con tu hijo. Si no es lo que
            esperabas: sin preguntas, sin formularios, sin drama.
            <span className="block mt-2 text-xs md:text-sm text-white/50 font-mono" data-id="element-139">
              (Tasa de devoluciones &lt; 1%)
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}